import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import productApi from '../../api/product.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import styles from '../../styles/product.module.scss'

const ProductListPage = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [productStatusCount, setProductStatusCount] = useState({
    total: 0,
    selling: 0,
    soldOut: 0,
    unsold: 0,
  })
  const [categoryOption, setCategoryOption] = useState({
    category1: { categoryLevel: 'LARGE', categoryParent: '0' },
    category2: {},
    category3: {},
  })
  const [searchOptions, setSearchOptions] = useState({
    productId: null,
    productMakerName: '',
    productName: '',
    brandName: '',
    productStatus: 'selling',
    category1: '',
    category2: '',
    category3: '',
  })
  const [category1, setCategory1] = useState([
    { categoryId: '', categoryName: '대분류' },
  ])
  const [category2, setCategory2] = useState([
    { categoryId: '', categoryName: '중분류' },
  ])
  const [category3, setCategory3] = useState([
    { categoryId: '', categoryName: '소분류' },
  ])
  const [productItemList, setProductItemList] = useState([])
  const [selectedRowKey, setSelectedRowKey] = useState([])
  // const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalSize, setTotalSize] = useState(0)
  const [orderBy, setOrderBy] = useState('desc')
  const [orderType, setOrderType] = useState('createdAt')

  const rowSelection = {
    type: 'radio',
    selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys)
      // setSelectedRow(selectedRows);
    },
  }

  const columns = [
    {
      title: '상품번호',
      width: 80,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
      fixed: 'left',
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '카테고리',
      width: 120,
      dataIndex: 'categoryName',
      key: 'categoryName',
      ellipsis: true,
      render: (value) => {
        if (value === '') {
          return <span>-</span>
        } else {
          return value
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '브랜드명',
      width: 130,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '상품명',
      width: 200,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '상품 상태',
      width: 100,
      dataIndex: 'isPurchase',
      key: 'isPurchase',
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity < 1) {
          return <span>품절</span>
        } else if (value) {
          return <span>판매중</span>
        } else {
          return <span>미판매</span>
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '노출여부',
      width: 100,
      dataIndex: 'isShow',
      key: 'isShow',
      ellipsis: true,
      render: (value) => {
        if (value) {
          return '노출'
        } else {
          return '미노출'
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '재고수량',
      width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
      render: (value) => {
        if (value < 1) {
          return <span>품절</span>
        } else {
          return <span>{value.toLocaleString()}</span>
        }
      },
    },
    {
      title: '판매자',
      width: 120,
      dataIndex: 'sellerName',
      key: 'sellerName',
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '판매가',
      width: 90,
      dataIndex: 'price1',
      key: 'price1',
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
      render: (value) => <span>{value.toLocaleString()}</span>,
    },
    {
      title: '할인가',
      width: 90,
      dataIndex: 'price2',
      key: 'price2',
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    // {
    //   title: '배송특성',
    //   width: 90,
    //   dataIndex: 'delivery_type',
    //   key: 'delivery_type',
    //   ellipsis: true,
    //   // sorter: (a, b) => {},
    //   onCell: (record) => {
    //     return {
    //       onClick: () => {
    //         navigate(`/product/register/${record.productId}`)
    //       },
    //     }
    //   },
    // },
    {
      title: '배송비',
      width: 90,
      dataIndex: 'deliveryPrice',
      key: 'deliveryPrice',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === null || value === 0) {
          return <span>-</span>
        } else {
          return value?.toLocaleString()
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    {
      title: '등록일',
      width: 160,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            navigate(`/product/register/${record.productId}`)
          },
        }
      },
    },
    // {
    //     title: '등록자',
    //     width: 90,
    //     dataIndex: 'created_by_name',
    //     key: 'created_by_name',
    //     ellipsis: true,
    //     onCell: (record) => {
    //         return {
    //             onClick: () => {
    //                 history.push(`/product/register/${record.productId}`)
    //             }
    //         }
    //     }
    // }
  ]

  const productStatusItems = [
    { label: '판매중', value: 'selling' },
    { label: '품절', value: 'soldOut' },
    { label: '미판매', value: 'unsold' },
    { label: '전체', value: 'total' },
  ]

  const orderPair = {
    productId: '상품번호순',
    quantity: '재고수량순',
    price1: '판매가',
    price2: '할인가',
    // delivery_type: '배송특성순',
    deliveryPrice: '배송비순',
    createdAt: '상품등록일순',
  }

  useEffect(() => {
    getProductStatusInfo()
    getCategoryList(categoryOption.category1)
    readProductList('initial')
  }, [])

  useEffect(() => {
    readProductList()
  }, [offset, pageSize, orderType, orderBy])

  const getProductStatusInfo = async () => {
    setIsLoading(true)
    try {
      const res = await productApi.readProductCntByStatus(user.id)
      if (res.data.code === 200) {
        setProductStatusCount({
          total: res.data.result.totalCnt,
          selling: res.data.result.sellingCnt,
          soldOut: res.data.result.soldOutCnt,
          unsold: res.data.result.unsoldCnt,
        })
        setIsLoading(false)
      } else {
        setIsLoading(false)
        alert('정상적인 요청이 아닙니다.')
      }
    } catch (error) {
      setIsLoading(false)
      console.log('getProductStatusInfo read error', error)
    }
  }

  const getCategoryList = async (param) => {
    setIsLoading(true)
    try {
      const res = await productApi.readCategoryList(param)
      if (res.data.code === 200) {
        if (param.categoryLevel === 'LARGE') {
          setCategory1([
            { categoryId: '', categoryName: '대분류' },
            ...res.data.result,
          ])
          setCategory2([{ categoryId: '', categoryName: '중분류' }])
          setCategory3([{ categoryId: '', categoryName: '소분류' }])
        } else if (param.categoryLevel === 'MEDIUM') {
          setCategory2([
            { categoryId: '', categoryName: '중분류' },
            ...res.data.result,
          ])
          setCategory3([{ categoryId: '', categoryName: '소분류' }])
        } else if (param.categoryLevel === 'SMALL') {
          setCategory3([
            { categoryId: '', categoryName: '소분류' },
            ...res.data.result,
          ])
        }
        setIsLoading(false)
      } else {
        setIsLoading(false)
        alert('정상적인 요청이 아닙니다.')
      }
    } catch (error) {
      setIsLoading(false)
      console.log('getCategoryList read error', error)
    }
  }

  const readProductList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          productId: null,
          productMakerName: '',
          productName: '',
          brandName: '',
          category2: '',
          category3: '',
          productStatus: 'selling',
          orderType: 'createdAt',
          orderBy: 'desc',
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          ...searchOptions,
          orderType: orderType,
          orderBy: orderBy,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          ...searchOptions,
          orderType: orderType,
          orderBy: orderBy,
        }
      }
      // console.log('param', param)
      const res = await productApi.readProductList(param, user.id)
      if (res.data.code === 200) {
        setProductItemList(res.data.result.productDTOList)
        setTotalSize(res.data.result.totalCnt)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        alert('정상적인 요청이 아닙니다.')
      }
    } catch (error) {
      setIsLoading(false)
      console.log('readProductList read error', error)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'productId') {
      const reg = /^[0-9]*$/
      if (value === '') {
        setSearchOptions({ ...searchOptions, [name]: null })
      } else if (reg.test(value)) {
        setSearchOptions({ ...searchOptions, [name]: value })
      }
    } else {
      setSearchOptions({ ...searchOptions, [name]: value })
    }
  }

  const handleSelectChange = (value, e) => {
    let searchCategory = {}
    if (e.id === 'product_category_1') {
      searchCategory = { categoryLevel: 'MEDIUM', categoryParent: value }
      setCategoryOption({
        ...categoryOption,
        category2: searchCategory,
        category3: {},
      })
      setSearchOptions({ ...searchOptions, category1: value })
      getCategoryList(searchCategory)
    } else if (e.id === 'product_category_2') {
      searchCategory = { categoryLevel: 'SMALL', categoryParent: value }
      setCategoryOption({ ...categoryOption, category3: searchCategory })
      setSearchOptions({ ...searchOptions, category2: value })
      getCategoryList(searchCategory)
    } else if (e.id === 'product_category_3') {
      setSearchOptions({ ...searchOptions, category3: value })
    }
  }

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('createdAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset(0)
    setCurrentPageNumber(1)
  }

  /**
   * 검색 버튼
   */
  const handleSearchBtnClick = async () => {
    if (searchOptions.category1 !== '' && searchOptions.category2 === '') {
      window.alert(
        '카테고리를 중분류까지 선택하거나 초기화한 뒤에 다시 검색해주시길 바랍니다.',
      )
    } else {
      setOffset(0)
      setCurrentPageNumber(1)
      readProductList('search')
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      productId: null,
      productMakerName: '',
      productName: '',
      brandName: '',
      productStatus: 'selling',
      category1: '',
      category2: '',
      category3: '',
    })
    setCategoryOption({
      category1: { categoryLevel: 'LARGE', categoryParent: '0' },
      category2: {},
      category3: {},
    })
    setOffset(0)
    setCurrentPageNumber(1)
    setOrderType('createdAt')
    setOrderBy('desc')
    readProductList('initial')
  }
  // useEffect(() => {
  //   console.log('rowSelection', rowSelection)
  // }, [rowSelection])

  return (
    <>
      <ContentHeader title="상품 조회/수정" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }} // TODO: 사이즈 고려 중
      >
        {/*상품조회 status*/}
        <Row
          justify="space-around"
          className={`${styles['product-search-product-status-wrap']}`}
        >
          {/*전체*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>전체</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {productStatusCount.total}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*판매중*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>판매중</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {productStatusCount.selling}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*품절*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>품절</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {productStatusCount.soldOut}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*미판매*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>미판매</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {productStatusCount.unsold}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*상품검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" style={{ marginBottom: 15 }}>
              <label className={`${styles['product-search-box-input-label']}`}>
                상품번호
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="productId"
                value={
                  searchOptions.productId === 0 ? '' : searchOptions.productId
                }
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label className={`${styles['product-search-box-input-label']}`}>
                제조사명
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="productMakerName"
                value={searchOptions.productMakerName}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
            <Row align="middle">
              <label className={`${styles['product-search-box-input-label']}`}>
                상품명
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="productName"
                value={searchOptions.productName}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label className={`${styles['product-search-box-input-label']}`}>
                브랜드명
              </label>
              <Input
                className={`${styles['product-search-box-input-wrap']}`}
                name="brandName"
                value={searchOptions.brandName}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="상품 상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="productStatus"
              value={searchOptions.productStatus}
              options={productStatusItems}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Select
                className={`${styles['product-search-category-select']}`}
                placeholder="대분류"
                value={searchOptions.category1}
                onChange={handleSelectChange}
              >
                {category1?.length !== 0 && (
                  <>
                    {category1.map((category, idx) => (
                      <Select.Option
                        key={`category1_${idx}`}
                        id="product_category_1"
                        value={category.categoryId}
                      >
                        {category.categoryName}
                      </Select.Option>
                    ))}
                  </>
                )}
              </Select>
              <Select
                className={`${styles['product-search-category-select']}`}
                placeholder="중분류"
                value={searchOptions.category2}
                onChange={handleSelectChange}
                disabled={Object.keys(categoryOption.category2)?.length === 0}
              >
                {category2?.length !== 0 && (
                  <>
                    {category2.map((category, idx) => (
                      <Select.Option
                        key={`category2_${idx}`}
                        id="product_category_2"
                        value={category.categoryId}
                      >
                        {category.categoryName}
                      </Select.Option>
                    ))}
                  </>
                )}
              </Select>
              <Select
                className={`${styles['product-search-category-select']}`}
                placeholder="소분류"
                value={searchOptions.category3}
                onChange={handleSelectChange}
                disabled={Object.keys(categoryOption.category3)?.length === 0}
              >
                {category3?.length !== 0 && (
                  <>
                    {category3.map((category, idx) => (
                      <Select.Option
                        key={`category3_${idx}`}
                        id="product_category_3"
                        value={category.categoryId}
                      >
                        {category.categoryName}
                      </Select.Option>
                    ))}
                  </>
                )}
              </Select>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          {/*<Form.Item*/}
          {/*    className={`${styles['center-label']}`}*/}
          {/*    label="기간"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{ span: 3 }}*/}
          {/*    wrapperCol={{ span: 21 }}*/}
          {/*>*/}

          {/*</Form.Item>*/}
          {/*<Divider className={`${styles['product-register-form-input-divider']}`} />*/}
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*상품목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            상품목록 (총{' '}
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{ marginLeft: 0 }}
            >
              {totalSize}
            </span>
            개)
          </span>
          <span className={`${styles['product-list-subtitle']}`}>
            {orderPair[orderType]}
          </span>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={productItemList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="productId"
            rowClassName="coupon-table-row"
            scroll={{ x: 'calc(700px + 50%)' }}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showQuickJumper
            showSizeChanger
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
      </div>
    </>
  )
}

export default ProductListPage
